import { IComboBoxOption, MessageBarType } from "@fluentui/react";
import { IVisioRDFS, SemTalkRibbon, SemTalkShapeType } from "./application/semtalklistener/visiordfsinterface";
import { SemTalkShape, SemTalkStencil } from "@semtalk/global";
import { IObjectBase, ISemTalkClass, ISemTalkDiagram, ISemTalkDiagramType, ISemTalkObject, SemTalkID, SemTalkJSON, SemTalkLanguage } from "@semtalk/tbase";
import { SemTalkCookie } from "./ISemTalkCookie";
import { ITSEditor } from "./ITSEditor";
import { IMongoOption } from "@semtalk/mongodb";
import { IExportConnection } from "./portalexport";
import { Client } from "@microsoft/microsoft-graph-client";

export enum SemTalkOnlineCommand {
  NewDocument = "NewDocument",
  OpenDocument = "OpenDocument",
  SaveDocument = "SaveDocument",
  SaveAsDocument = "SaveAsDocument",
  DeleteDocument = "DeleteDocument",
  CloseDocument = "CloseDocument",
  AutoSave = "AutoSave",
  UploadDocument = "UploadDocument",
  DownloadDocument = "DownloadDocument",
  ImportDocument = "ImportDocument",
  UploadPlainJSON = "UploadPlainJSON",
  DownloadPlainJSON = "DownloadPlainJSON",
  MergeDocuments = "MergeDocuments",
  ImportOWLFile = "ImportOWLFile",
  ImportJSONLDFile = "ImportJSONLDFile",
  ImportXMLFile = "ImportXMLFile",
  ImportEPMLFile = "ImportEPMLFile",
  DownloadWordFile = "DownloadWordFile",
  DownloadHTMLFile = "DownloadHTMLFile",
  DownloadXMLFile = "DownloadXMLFile",
  DownloadPNGFile = "DownloadPNGFile",
  DownloadPDFFile = "DownloadPDFFile",
  DownloadJPGFile = "DownloadJPGFile",
  DownloadOWLFile = "DownloadOWLFile",
  DownloadJSONLDFile = "DownloadJSONLDFile",
  DownloadSVGFile = "DownloadSVGFile",
  PublishXMLFile = "PublishXMLFile",
  PublishV2 = "PublishV2",
  CheckInDocument = "CheckInDocument",
  CheckOutDocument = "CheckOutDocument",
  FileImage = "FileImage",
  PrintPreview = "PrintPreview",
  StartPanning = "StartPanning",
  StopPanning = "StopPanning",
  TogglePanZoom = "TogglePanZoom",
  ToggleStencil = "ToggleStencil",
  ToggleChatBot = "ToggleChatBot",
  ToggleNavigator = "ToggleNavigator",
  TogglePlanner = "TogglePlanner",
  ToggleSearch = "ToggleSearch",
  LangGraph = "LangGraph",
  TogglePages = "TogglePages",
  ToggleBackground = "ToggleBackground",
  DeleteShapes = "DeleteShapes",
  SelectAll = "SelectAll",
  SendToBack = "SendToBack",
  BringToFront = "BringToFront",
  Undo = "Undo",
  Redo = "Redo",
  ShapeStyle = "ShapeStyle",
  ConnectionPoints = "ConnectionPoints",
  DistributeCells = "DistributeCells",
  DistributeCellsVert = "DistributeCellsVert",
  DistributeCellsHor = "DistributeCellsHor",
  AlignHorizontalLeft = "AlignHorizontalLeft",
  AlignHorizontalCenter = "AlignHorizontalCenter",
  AlignHorizontalRight = "AlignHorizontalRight",
  AlignVerticalTop = "AlignVerticalTop",
  AlignVerticalCenter = "AlignVerticalCenter",
  AlignVerticalBottom = "AlignVerticalBottom",
  ZoomIn = "ZoomIn",
  ZoomOut = "ZoomOut",
  ZoomFit = "ZoomFit",
  ZoomActual = "ZoomActual",
  Center = "Center",
  Redraw = "Redraw",
  Reload = "Reload",
  TogglePageBreaks = "TogglePageBreaks",
  EditObject = "EditObject",
  SelectCell = "SelectCell",
  InsertWayPoint = "InsertWayPoint",
  RemoveWayPoint = "RemoveWayPoint",
  ElbowCell = "ElbowCell",
  EditClass = "EditClass",
  DeleteObject = "DeleteObject",
  ToClass = "ToClass",
  ToInstance = "ToInstance",
  CompactShape = "CompactShape",
  DeleteHierarchy = "DeleteHierarchy",
  ComposeObject = "ComposeObject",
  UnComposeObject = "UnComposeObject",
  UpdateRepository = "UpdateRepository",
  TranslateObject = "TranslateObject",
  PlannerTasks = "PlannerTasks",
  Planner = "Planner",
  ConnectShapes = "ConnectShapes",
  HyperlinkObject = "HyperlinkObject",
  RefineObject = "RefineObject",
  DetachObject = "DetachObject",
  GoBack = "GoBack",
  GoForward = "GoForward",
  CustomizeObject = "CustomizeObject",
  InsertSwimlane = "InsertSwimlane",
  ToggleDirection = "ToggleDirection",
  CollapseCell = "CollapseCell",
  RefreshObject = "RefreshObject",
  ExportObject = "ExportObject",
  RefreshPage = "RefreshPage",
  ReorderPages = "ReorderPages",
  ExpandObject = "ExpandObject",
  EditPage = "EditPage",
  AddPage = "AddPage",
  DeletePage = "DeletePage",
  GoUp = "GoUp",
  Renumber = "Renumber",
  Insert = "Insert",
  Termstore = "Termstore",
  SiteBuilder = "SiteBuilder",
  mxSwimlaneLayout = "mxSwimlaneLayout",
  mxHierarchicalLayout = "mxHierarchicalLayout",
  mxCompactTreeLayout = "mxCompactTreeLayout",
  mxCompactTreeLayoutV = "mxCompactTreeLayoutV",
  mxCompactTreeLayoutI = "mxCompactTreeLayoutI",
  mxCompactTreeLayoutVI = "mxCompactTreeLayoutVI",
  mxFastOrganicLayout = "mxFastOrganicLayout",
  mxRadialTreeLayout = "mxRadialTreeLayout",
  mxCircleLayout = "mxCircleLayout",
  SelectDataLang = "SelectDataLang",
  SelectGuiLang = "SelectGuiLang",
  ShowHelp = "ShowHelp",
  ShowForm = "ShowForm",
  ShowOptions = "ShowOptions",
  ResetMetaModel = "ResetMetaModel",
  AddonCommand = "AddonCommand",
  WordVectors = "WordVectors",
  InvertedTaxonomy = "InvertedTaxonomy",
  MS365Login = "MS365Login",
  MS365Role = "MS365Role",
  MS365Logout = "MS365Logout",
  mgLogin = "mgLogin",
  mgLogout = "mgLogout",
  mgUserProfile = "mgUserProfile",
  mgUserManager = "mgUserManager",
  GroupShapes = "GroupShapes",
  UngroupShapes = "UngroupShapes",
  AddShape = "AddShape",
  AddQuickShape = "AddQuickShape",
  SetStyle = "SetStyle",
  SelectLeft = "SelectLeft",
  SelectRight = "SelectRight",
  SelectUp = "SelectUp",
  SelectDown = "SelectDown",
  Speech = "Speech",
  ReportManager = "ReportManager",
  LoadDefaultSettings = "LoadDefaultSettings",
  SaveDefaultSettings = "SaveDefaultSettings",
  ExportDefaultSettings = "ExportDefaultSettings",
  ImportDefaultSettings = "ImportDefaultSettings",
  ResetSettings = "ResetSettings",
  CheckandRepair = "CheckandRepair",
  ApproveDocument = "ApproveDocument",
  Simulation = "Simulation",
  ShareDocument = "ShareDocument",
  TextField = "TextField",
  ChatGPT = "ChatGPT",
  SpeakChatGPT = "SpeakChatGPT",
  PromptManager = "PromptManager",
  QuestionManager = "QuestionManager",
  StorageManager = "StorageManager",
  HeaderFooter = "HeaderFooter",
  Images = "Images",
  ExportBackgroundSettings = "ExportBackgroundSettings",
  ImportBackgroundSettings = "ImportBackgroundSettings",
  Documents = "Documents",
  VersionControl = "VersionControl",
  EditStencil = "EditStencil",
  EditRibbon = "EditRibbon",
  RenameObjects = "RenameObjects",
  Search = "Search",
  Code = "Code",
  Charting = "Charting",
  Impressum = "Impressum",
  Dashboard = "Dashboard",
  Privacy = "Privacy",
  ModelProperties = "ModelProperties",
  Copy = "Copy",
  Cut = "Cut",
  Paste = "Paste",
  Layout = "Layout",
  KeyManager = "KeyManager",
  CustomLayout = "CustomLayout",
  ExportManager = "ExportManager",
  Consistency = "Consistency",
  ExportMSProject = "ExportMSProject",
  Registration = "Registration",
  Unify = "Unify",
  Consent = "Consent",
  CopyDocuments = "CopyDocuments",
  ChangeLog = "ChangeLog",
  MakeSuggestion = "MakeSuggestion",
  WebPartPage = "WebPartPage",
  SAPR3 = "SAPR3" 
}
export interface ISemTalkOnline {
  // filename: string;
  ID(): string;
  GetFilename(): string;
  SetFilename(filename: string, islru: boolean): void;
  GetElectronFilename(): string;
  SetElectronFilename(filename: string): void;
  DoCommand(cmd: SemTalkOnlineCommand, args: any): void;
  ParseMenu(ribbon: SemTalkRibbon): { "items": any[], "allitems": any };
  SetRibbon(ribbon: SemTalkRibbon, toolbar: SemTalkRibbon): void;
  ResetRibbon(): void;
  GetTextFieldsDiagramMenu(): any;
  GetTextFieldsModelMenu(): any;
  // GetTextFieldsModelAttributeMenu(): any;
  ShowSubTask(addoncommand: string): void;
  resumeSessionStatus(forcenew: boolean, mongo: IMongoOption,
    loadtemplate: boolean, loadrecent: boolean, role: string, isopen: boolean): void;
  getLabel(cell: mxCell, tmp: string): string;
  getTextLabel(cell: mxCell, tmp: string): string;
  getLinkLabel(cell: mxCell, tmp: string): string;
  getTooltipForCell(cell: mxCell): string;
  isCellResizable(cell: mxCell): boolean;
  isCellEditable(cell: mxCell): boolean;
  isWrapping(_cell: mxCell): boolean;
  GetShapeStyle(key: string, shapeType: SemTalkShapeType): { style: string, isedge: boolean };
  setEditor(tseditor: ITSEditor): void;
  shapeCreatePopupMenu(_graph: mxGraph, _menu: mxPopupMenuHandler, cell: mxCell, evt: PointerEvent, _edi: ITSEditor): void;
  dockingPopupMenu(tool: string, evt: any, tseditor: ITSEditor): void;
  shapeAdded(cell: mxCell): void;
  shapeDeleted(cells: mxCell[]): void;
  isValid(src: mxCell, dst: mxCell): boolean;
  shapeExitedTextEdit(cell: mxCell, newValue: any): void;
  shapeSelectionChanged(cell: mxCell | undefined, evt: mxEventObject): void;
  shapeConnectionAdded(event: mxEventObject, edge: mxCell, source: mxCell, target: mxCell): void;
  shapeConnectionsDeleted(edge: mxCell): void;
  shapeCellConnected(edge: mxCell): void;
  shapeMoveCells(cells: mxCell[], clone: boolean, mxevt: mxEventObject): void;
  shapeResizeCells(cells: mxCell[], mxevt: mxEventObject): void;
  shapeCopyCells(cells: mxCell[]): void;
  // selectCell(cell: mxCell): void;
  editCell(cell: mxCell): void;
  // composeCell(cell: mxCell): void;
  quickShapes(cell: mxCell): SemTalkStencil;
  insertQuickShape(m: SemTalkShape, cell: mxCell | null): mxCell | null;
  makeInstance(class_cell: mxCell, inst_cell: mxCell): void;
  makeSubClass(class_cell: mxCell, subcl_cell: mxCell): void;
  editObject(id: SemTalkID): void;
  // selectDataLang(lang: SemTalkLanguage): void;
  keyPressed(evtobj: KeyboardEvent): void;
  hasKeyHandler(evtobj: KeyboardEvent): boolean;
  selectLeft(): void;
  selectRight(): void;
  selectUp(): void;
  selectDown(): void;
  selectPageUp(): void;
  selectPageDown(): void;

  showShapeStyle(cells: mxCell[]): void;
  showHelp(page?: string): void;
  gotoPage(diagid: SemTalkID): void;
  newPage(pname: string, parent: ISemTalkObject | null, diagtype: ISemTalkDiagramType, init: boolean): Promise<ISemTalkDiagram | null>;
  alert(msg: string, mtype: MessageBarType): void;
  beginTransaction(reason: string): void;
  endTransaction(reason: string, objectid: SemTalkID | null): void;
  RecordTransaction(reason: string, objectid: SemTalkID | null, shapeids: string[]): void;
  RecordCommentTransaction(reason: string, objectid: SemTalkID | null, shapeids: string[], comment: string): void;
  DeleteTransaction(trans: IChangelogEntry, ball: boolean): void;
  // updateDiaglist(): void;
  openlocalDocument(filetype: string): void;
  savelocalDocument(filename: string, filetype: string): void;
  openDocumentCallBack(filename: string, folder?: string): void;
  newDocumentCallBack(template: string): void;
  importDocumentCallBack(filename: string): void;
  mergeDocumentsCallBack(files: any[]): Promise<void>;
  publishDocumentsCallBack(files: any[], publishBg: boolean): Promise<void>;
  importlocalDocument(): void;
  loadDocumentFromJSON(filename: string, s: SemTalkJSON, iselectron: boolean): Promise<void>;
  saveAsDocumentCallBack(filename: string, folder: string, ext: string): void;
  deleteDocumentCallBack(filename: string, mongo?: IMongoOption, publishing?: boolean): void;
  restoreVersionCallBack(): void;
  // getmxGraphXML(diag: ISemTalkDiagram): string;
  // defaultFont(): string;
  getMongoDBDocumentMetaData(filename: string): any;
  isConnectionPoints(): boolean;
  isForward(): boolean;
  isBackward(): boolean;
  isApprovable(forFile: boolean): boolean;
  composeObjectCallback(oclass: ISemTalkClass): void;
  loadPage(oid: SemTalkID, semtalk: IVisioRDFS, init: boolean): Promise<void>;
  saveCurrentGraph(): void;
  encode(s: string): string;
  decode(s: string): string;
  IsMongo(): boolean;
  IsGraph(): boolean;
  GetDefaultValue(settings: any, setting: SemTalkCookie, defaultvalue: any): any;
  CreateDocument(sem: IVisioRDFS, template: string, initpage: boolean): Promise<void>;
  LoadDocument(filename: string, usecache: boolean, folder?: string): Promise<void>;
  SetSelectedFile(filename: string): void;
  SetSelectedFiles(filenames: string[]): void;
  SetSelectedBackupFile(filename: string, content: string): void;
  SetSelectedExternalOb(ob: IObjectBase | null): void;
  SetSelectedFileType(filetype: string): void;
  SetSelectedFolder(foldername: string): void;
  SetSelectedExists(exists: boolean): void;
  SetSelectedDiagram(diagname: string): void;
  SetSelectedDiagramType(diagramtype: ISemTalkDiagramType): void;
  SetSelectedLanguage(language: SemTalkLanguage): void;
  SetSelectedExportConnection(exportConnection: IExportConnection): void;
  SetSelectedExportLibrary(exportLibrary: string): void;
  SetGraphLocation(site: string, lib: string, folder: string): void;
  SetImages(images: any[]): void;
  GetImages(): IImage[];
  SetPublishBg(publishBg: boolean): void;
  getDocumentJSON(): any;
  getDocumentsMetaData(): Promise<IComboBoxOption[]>;
  MS365Login(required_scopes: string[]): Promise<any>;
  // MS365Logout(required_scopes: string[]): Promise<any>;
  MS365Token(required_scopes: string[]): Promise<any>;
  getSharePointContext(): any;
  SetProgressIndicator(status: string, progress: number): void;
  updateModelTextFields(): void;
  SetState(s: any): void;
  InsertObject(_semtalk: IVisioRDFS, _shape: any, newobjs: ISemTalkObject[], expand: boolean): void;
  InsertObjects(newobjs: ISemTalkObject[], expand: boolean, reusenodes: boolean): void;
  ResetModelProperties(): void;
  setModelCookie(cookie: SemTalkCookie, val: any): void;
  removeModelCookie(cookie: SemTalkCookie): void;
  reloadFromSettingsPanel(): void;
  GetRole(): string;
  IsCheckedout2me(): boolean;
  IsCheckedout(): boolean;
  IsModified(): boolean;
  IsUpdateAvailable(): boolean;
  PostGraph(query: string, verb: string, args: any, etag: boolean, fields: boolean,
    filter: string, expand: string): any;
  GetSSOToken(): { serverurl: string, ssotoken: string } | null;
  GetGraphClient(): Client | null;
  swimlaneChanged(cell: mxCell | null): void;
  setSwimlaneHeaders(val: boolean): void;
  setSwimlaneSpacing(val: number): void;
  GetShowSwimlaneinBreadcrumbs(): boolean;
  SetExternalObjectbase(ob: IObjectBase): void;
  getPublish(): boolean;
  updateSVGPage(ob: IObjectBase, d: ISemTalkDiagram): string;
  SetWarning(warning: string, messagetype: MessageBarType, readonly: boolean): void;
  mouseMove(x: number, y: number): void;
  UploadCurrentDocument(backup: boolean): Promise<{ msg: string; msgtype: MessageBarType }>
  IsCopilot(): boolean;
  getUserID(): string;
  ShowExtDashboard(extdashboard: any): void;
  HideExtDashboard(): void;
}
export interface IImage {
  key: string;
  image: string;
  imagedata: string;
  inFile: boolean;
}
export interface ISemTalkSemantics {
  server: string;
  corpus: string;
  distance: number;
  tika: string;
}
export interface ISemTalkAI {
  server: string;
  model: string;
  temperature: number;
}
export interface IPortalOption {
  portalbackend: string;
  portalconnection: string;
  portaldb: string;
  portallib: string;
  portalmode: boolean;
  portalstartfile: string;
  portalstartdiagram: string;
  portalribbon: string;
  portalinstantrefine: string;
  portalforcestartdiagram: boolean;
}
export enum SemTalkRole {
  admin = "admin",
  publisher = "publisher",
  metamodel = "metamodel",
  editor = "editor",
  viewer = "viewer"
}

export enum PlannerAttribute {
  assignments = "Planner_assignments",
  // id = "Planner_id",
  // title = "Planner_title",
  bucketId = "Planner_bucketid",
  priority = "Planner_priority",
  completedBy = "Planner_completedBy",
  completedDateTime = "Planner_completedDateTime",
  createdBy = "Planner_createdBy",
  createdDateTime = "Planner_createdDateTime",
  description = "Planner_description",
  dueDateTime = "Planner_dueDateTime",
  // hasDescription = "Planner_hasDescription",
  percentComplete = "Planner_percentComplete",
  // planId = "Planner_planId",
  startDateTime = "Planner_startDateTime",
  status = "Planner_status",
}

export enum PlannerStatus {
  NotStarted = "NotStarted",
  InProgress = "InProgress",
  Late = "Late",
  Completed = "Completed",
}

export enum DocumentStatus {
  InApproval = "InApproval",
  InProgress = "InProgress",
  InPublishing = "InPublishing",
  Published = "Published",
  InReview = "InReview",
  Completed = "Completed",
  Approved = "Approved"
}

export interface IChangelogEntry {
  transaction: string;
  objectid: string;
  shapeids: string[];
  timestamp: string;
  userId: string;
  pageId: string;
  comments: { text: string, type: string, userId: string }[]
}